export const formatKeywordByMatchType = (
    keyword: string,
    matchType: string
) => {
    if (!keyword) return "";

    switch (matchType) {
        case "PHRASE":
            return `"${keyword}"`;

        case "EXACT":
            return `[${keyword}]`;

        case "BROAD":
        default:
            return keyword;
    }
};